module.exports = __webpack_public_path__ + "img/sidebar-toggle-on_hover.444e7fea.svg";